import {FormikProps} from 'formik';
import {
  OptionsProp,
  Query,
  TreatmentResponseProps
} from '../../constants/types';

export type NewSurveyFormData = {
  patientId: string,
  callSheetId: string,
  patientName: string,
}

export type NewSurveyFormSendData =
  Omit<NewSurveyFormData, 'patientName'>

export type AddSurveyResponse = {
  surveyId: number,
}

type AvailableCallSheet = {
  id: number,
  currentlyInUse: boolean,
  appointment: {
    id: number,
    appointmentDate: string,
    wantsSooner: boolean,
    treatment: TreatmentResponseProps,
    operatory: {
      id: number,
      number: number,
      desc: string,
      currentlyInUse: boolean,
    }
  }
}

export type AvailablePatient = {
  id: number,
  firstName: string,
  lastName: string,
  patientId?: Nullable<string>,
  callSheets: AvailableCallSheet[]
}

export type PatientOptionLabel =
  Omit<AvailablePatient, 'patientId' | 'callSheets'>

export type PatientOptions = OptionsProp[]
export type PatientsCallSheets = Dictionary<OptionsProp[]>

export type MappedPatients = {
  patientsCallSheets: PatientsCallSheets,
  patientOptions: PatientOptions,
}

export type AddSurveyFormProps = {
  patientsOptions: PatientOptions,
  patientsCallSheets: PatientsCallSheets,
  backToSurveyList: () => void,
  formikProps: FormikProps<NewSurveyFormData>
}

export type SingleTreatment = {
  id: number,
  code: string,
  name: string
}

export type Treatment = {
  rootId: number,
  displayName: string,
  allTreatments: SingleTreatment[]
}

export type SurveyListItem = {
  surveyId: number,
  dateCreated: string,
  patientFirstName: string,
  patientLastName: string,
  treatment: Nullable<Treatment>,
  completed: boolean
}

export type SurveyRowProps = {
  survey: SurveyListItem,
  contentLength: number,
  openModal: (data: SurveyToDelete) => void
}

export type SurveyToDelete = {
  id: number,
  message: string,
  contentLength: number,
  patientName: string
}

export type SurveyListQuery = Query & {
  completed: string,
  date_created: string
}

export type PatientSurveyProps = {
  id: number,
  parentId: number,
  seqNum: number,
  label: string,
  required: boolean,
  type: SurveyComponentTypes,
  details: string,
  answer?: string,
  children?: PatientSurveyProps[]
}

export type PatientSurveyResponseProps = PatientSurveyProps[];

export enum SurveyComponentTypes {
  INFO = 'INFO',
  HEADER = 'HEADER',
  RATING_HEADER = 'RATING_HEADER',
  TEXT = 'TEXT',
  TEXTAREA = 'TEXTAREA',
  RATING = 'RATING',
  RADIO = 'RADIO'
}

export type RatingHeaderDetailsProps = {
  min: number,
  max: number,
  step: number
}
